/* mo-bf-stage-hero: spotlight rotation, one-time digit roll, countdown (Hermes, lane stage, 2026-11-03).
   The server HTML holds every final string; this script only animates it. Dealer digits (data-roll="roll") roll up
   to their ledger value once. Rows marked static (Stearns & Foster, Sealy, Tempur-Pedic) never change a character.
   Reduced motion: no rotation, no roll, no sweep; the countdown updates once a minute. Save-Data: no rotation and
   no extra photos. Each brand photo loads one turn before it is shown. In hub mode a picked brand also filters the hub grid (mo-bf-sale-hub.js) and scrolls to it. */
(function () {
  'use strict';
  var mq = function (q) { return !!(window.matchMedia && window.matchMedia(q).matches); };
  var RM = mq('(prefers-reduced-motion: reduce)');
  var SD = !!(navigator.connection && navigator.connection.saveData);

  function endAt(ymd) {
    var y = +ymd.slice(0, 4), m = +ymd.slice(4, 6) - 1, d = +ymd.slice(6, 8);
    var t = Date.UTC(y, m, d, 28, 59, 59); /* 23:59:59 at UTC-5 */
    try {
      var h = +new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hour: '2-digit', hourCycle: 'h23' }).format(new Date(t));
      t -= (((h - 23 + 36) % 24) - 12) * 3600000;
    } catch (e) {}
    return t;
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function init(root) {
    if (root.__bfst) return; root.__bfst = 1;
    var rows = Array.prototype.slice.call(root.querySelectorAll('.mo-bfst__row'));
    if (!rows.length) return;
    var photos = {};
    Array.prototype.forEach.call(root.querySelectorAll('.mo-bfst__ph'), function (p) { photos[p.getAttribute('data-key')] = p; });
    var capName = root.querySelector('[data-bfst-cap-name]');
    var capLine = root.querySelector('[data-bfst-cap-line]');
    var cap = root.querySelector('.mo-bfst__cap');
    var clock = root.querySelector('[data-bfst-clock]');
    var pauseBtn = root.querySelector('[data-bfst-pause]');
    var auto = Math.max(3, parseInt(root.getAttribute('data-auto'), 10) || 6) * 1000;
    var useClock = root.getAttribute('data-clock') === '1';
    var useFlaps = root.getAttribute('data-flaps') === '1' && !RM;
    var hub = root.getAttribute('data-bfst-mode') === 'hub';
    root.style.setProperty('--st-auto', (auto / 1000) + 's');

    var idx = Math.max(0, rows.map(function (r) { return r.classList.contains('is-lit'); }).indexOf(true)), timer = 0, userPaused = false, hoverPaused = false, offscreen = false, running = false;

    function caption(row) {
      if (!row) return;
      var n = row.querySelector('.mo-bfst__name');
      var l = row.querySelector('[data-bfs-line]');
      if (capName) capName.textContent = n ? n.textContent : '';
      if (capLine) capLine.textContent = l ? l.textContent.replace(/\s+/g, ' ').trim() : '';
      tick();
    }
    function tick() {
      if (!clock || !useClock) return;
      var row = rows[idx];
      var ymd = row && row.getAttribute('data-end');
      if (!ymd || ymd.length !== 8) { clock.hidden = true; return; }
      var left = endAt(ymd) - Date.now();
      if (left <= 0) { clock.hidden = true; return; }
      var s = Math.floor(left / 1000), dd = Math.floor(s / 86400), hh = Math.floor(s % 86400 / 3600), mm = Math.floor(s % 3600 / 60), ss = s % 60;
      clock.textContent = (dd ? dd + (dd === 1 ? ' day ' : ' days ') : '') + pad(hh) + ':' + pad(mm) + (RM ? '' : ':' + pad(ss)) + ' left';
      clock.hidden = false;
    }
    function light(i, swapCap) {
      idx = (i + rows.length) % rows.length;
      var key = rows[idx].getAttribute('data-key');
      rows.forEach(function (r, j) { r.classList.toggle('is-lit', j === idx); });
      Object.keys(photos).forEach(function (k) {
        var p = photos[k];
        if (k === key) { hydrate(p); p.classList.add('is-on'); } else p.classList.remove('is-on');
      });
      caption(rows[idx]);
      if (running) hydrate(photos[rows[(idx + 1) % rows.length].getAttribute('data-key')]);
      if (swapCap && cap && !RM) { cap.classList.remove('is-swap'); void cap.offsetWidth; cap.classList.add('is-swap'); }
      if (!RM && running) { root.classList.remove('is-sweep'); void root.offsetWidth; root.classList.add('is-sweep'); }
    }
    function hydrate(p) {
      if (!p || p.__h) return; p.__h = 1;
      var s = p.querySelector('source[data-srcset]'); if (s) s.srcset = s.getAttribute('data-srcset');
      var im = p.querySelector('img[data-src]');
      if (im) { im.src = im.getAttribute('data-src'); if (im.decode) im.decode().catch(function () {}); }
    }
    function paused() { return userPaused || hoverPaused || offscreen || document.hidden; }
    function schedule() {
      clearTimeout(timer);
      if (!running || paused()) return;
      timer = setTimeout(function () { light(idx + 1, true); schedule(); }, auto);
    }

    /* one-time digit roll (dealer brands only) */
    if (useFlaps) {
      Array.prototype.forEach.call(root.querySelectorAll('.mo-bfst__deal[data-roll="roll"]'), function (deal) {
        var row = deal.closest('.mo-bfst__row');
        var i = row ? (parseInt(row.style.getPropertyValue('--i'), 10) || 0) : 0;
        var digits = Array.prototype.slice.call(deal.querySelectorAll('.mo-bfst__t i')).filter(function (g) { return /^[0-9]$/.test(g.textContent); });
        digits.forEach(function (g, j) {
          var target = +g.textContent, cur = 0;
          if (target === 0) return;
          g.textContent = '0';
          var start = 380 + i * 70 + 160 + j * 45;
          setTimeout(function step() {
            cur += 1;
            g.textContent = String(cur);
            if (g.animate) g.animate([{ transform: 'scaleY(1)' }, { transform: 'scaleY(.12)' }, { transform: 'scaleY(1)' }], { duration: 70, easing: 'ease-in-out' });
            if (cur < target) setTimeout(step, 62);
          }, start);
        });
      });
    }

    /* rows: hover or focus puts that brand in the spotlight */
    rows.forEach(function (r, j) {
      var pick = r.querySelector('.mo-bfst__pick');
      var show = function () { light(j, false); };
      r.addEventListener('mouseenter', show);
      if (pick) pick.addEventListener('focus', show);
      if (hub && pick) pick.addEventListener('click', function () {
        setTimeout(function () {
          if (pick.getAttribute('aria-pressed') !== 'true') return;
          var to = document.getElementById('bf-lineup');
          if (to) to.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' });
        }, 30);
      });
    });
    root.addEventListener('mouseenter', function () { hoverPaused = true; schedule(); });
    root.addEventListener('mouseleave', function () { hoverPaused = false; schedule(); });
    root.addEventListener('focusin', function () { hoverPaused = true; schedule(); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) { hoverPaused = false; schedule(); } });
    document.addEventListener('visibilitychange', schedule);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { offscreen = !es[0].isIntersecting; schedule(); }, { threshold: 0.15 }).observe(root);
    }

    /* compact page: open the finder's Black Friday filter in place when the chip exists */
    var filt = root.querySelector('[data-bfst-cta="filter"]');
    if (filt) filt.addEventListener('click', function (e) {
      var chip = document.querySelector('.mxf-chip--bf');
      var find = document.getElementById('find');
      if (!chip || !find) return;
      e.preventDefault();
      if (chip.getAttribute('aria-pressed') !== 'true') chip.click();
      find.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' });
    });

    caption(rows[idx]);
    if (useClock && clock) setInterval(tick, RM ? 60000 : 1000);

    /* rotation starts after the entrance and after the page has loaded; never under reduced motion or Save-Data */
    var canRun = rows.length > 1 && !RM && !SD;
    if (canRun && pauseBtn) {
      pauseBtn.hidden = false;
      pauseBtn.addEventListener('click', function () {
        userPaused = !userPaused;
        pauseBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', pauseBtn.getAttribute(userPaused ? 'data-play' : 'data-pause'));
        schedule();
      });
    }
    function begin() {
      if (!canRun) return;
      var ric = window.requestIdleCallback || function (f) { return setTimeout(f, 200); };
      /* start the push-in and rotation only after two painted frames: a page opened in a background tab gets no
         frames, and a transform transition started there could leave the first painted frame without the photo */
      var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
      ric(function () { raf(function () { raf(function () {
        if (running) return;
        hydrate(photos[rows[(idx + 1) % rows.length].getAttribute('data-key')]);
        running = true;
        root.classList.add('is-run');
        root.classList.add('is-sweep');
        schedule();
      }); }); });
    }
    if (document.readyState === 'complete') setTimeout(begin, 1400);
    else window.addEventListener('load', function () { setTimeout(begin, 1000); });
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-bfst]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
